import { Component, inject, input, output, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { UserSessionCoreDto, UserSessionId } from '@workspace/data-types';
import { LuxonDatePipe } from '@workspace/ng-aura';
import { SessionStorageKey } from '@workspace/ng-data-access';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'core-user-sessions',
  templateUrl: './user-sessions.component.html',
  imports: [MatIconModule, LuxonDatePipe, MatDividerModule, MatButtonModule],
  standalone: true,
})
export class UserSessionsCoreComponent {
  private cookieService = inject(CookieService);

  clientId = signal<string>(this.cookieService.get(SessionStorageKey.CLIENT_ID) as string);
  userSessions = input.required<UserSessionCoreDto[]>();
  revokeSession = output<UserSessionId>();
  revokeAllSession = output();
}
